import React from 'react';
import { sum } from '@shiftforex/shift-exchange-root';
import { multiply } from '@submodule/index.js';

const App: React.FC = () => {
  return (
    <div
      className="override-styles"
      style={{
        minHeight: '100vh',
        padding: '2rem',
        fontFamily: 'system-ui',
        backgroundColor: '#fff',
        color: '#000',
      }}
    >
      <h1>Hello World, mate:</h1>
      <p>Sum of 1 and 2 is <h1>{sum(1, 2)}</h1></p>
      <p>Multiply of 3 and 4 is <h1>{multiply(3, 4).toString()}</h1></p>
      <p>3 is for 1.0.0</p>
      <p>6 is for 1.0.1</p>
    </div>
  );
};

export default App;
